// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

const CombineAccounts = dynamic(() => import('./CombineAccounts').then(mod => mod.CombineAccounts));

export const CombineAccountsConfig = {
  emptyLabel: 'combineAccounts',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/combineaccounts`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CombineAccountsEditable = (props: any) => (
  <EditableComponent config={CombineAccountsConfig} {...props}>
    <CombineAccounts {...props} />
  </EditableComponent>
);
